import {Link} from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';
import RetinaImage from 'react-retina-image';

import {MainContent, Page, PageBody, PageHeader, SideNavigationBar} from '../../layout/components';

export default function IntroductionPage() {
  return (
    <Page pageClassName="introduction-page">
      <PageHeader title="Introduction" />
      <PageBody>
        <SideNavigationBar />
        <MainContent>
          <div className="introduction">
            <div className="left-hand">
              <div className="title">PROJECT TEAM HOUSE GUIDE</div>
              <div className="subtitle">ARE YOU IN THE HOUSE?</div>
              <div className="introductory-paragraph">The Project TEAM House is central to the entire Project TEAM program. It is a significant symbol for students to relate to and understand how the foundations build one upon another. We All come from a variety of backgrounds, some good...some not so good. The PT House is meant to be a symbol of hope and a place where we ALL belong. Students must understand that when they step into the PT House, they are stepping into a place where everyone is on the same TEAM. Through learning about the foundations of Project TEAM, students are given the tools they need to be able to take the PT house with them anywhere they go. It is also where the Project TEAMmates hang out!</div>
              <div>
                <RaisedButton
                  className="raised-button--rounded"
                  label="Get Started With Harper"
                  primary
                  containerElement={<Link to={'/detail/1'} />} />
              </div>
            </div>
            <div className="right-hand">
              <div className="foundation-image">
                <RetinaImage src={[require('../images/img-haus-Foundation.png'), require('../images/img-haus-Foundation@2x.png')]} />
              </div>
            </div>
          </div>
        </MainContent>
      </PageBody>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./app/features/introduction/components/IntroductionPage.js